import React, { useEffect } from "react";
import "./landingPage.css";
import { Helmet } from "react-helmet";
import LandingCarousel from "../landingCarousel/landingCarousel";
import MultiCarousel from "../multiCarousel/multiCarousel";
import Promotions from "../promotions/promotions";
import Loading from "../loading/loading";
import DownloadApp from "../downloadApp/downloadApp";
import Footer from "../../base/footer/footer";
import TopMenu from "../topMenu/topMenu";
import Header from "../header/header";
import { useLocation, Link as LinkRoute } from "react-router-dom";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { getPageData, justURLString, validatePath } from "../../../utils/generals";

let query = `
{
    landingPageAppCollection (where: {seoMetadata: {path:"&slug&"}}) {
      items{
        internalName
        pageTitle
        slug
        urlAccount
        seoMetadata{
          description
          hreflang
          href
          keywords
          canonicalHref 
        }
        nav{
          logo {
            url
          }
          menuItems
        }
        carouselLp
        multiCarouselCollection{
          items{
            url
            title
            description
          }
        }
        promotions{
          internalName
          categories
          promotions
          title{
            json
          }
        }
        uses{
          leftImage {
              url
            }
            text{
              json
            }
            uses
          }
          benefits {
            title
            benefits
          }
          downloadAppButtons{
            title
            downloadButtons
          }
          footer{
            text
            socialMedia
        }
      }
    }
  }
`;

const LandingPage = () => {
  const [page, setPage] = React.useState(null);
  const location = useLocation();
  const [keyCountry, setKeyCountry] = React.useState(null);

  useEffect(() => {
    
    query = query.replace("&slug&", validatePath(location.pathname));
    const pageData = getPageData(query);

    const codeCountry = String(location.pathname).split("/");
    setKeyCountry(codeCountry[1]);

    pageData
      .then((res) => {
        res.landingPageAppCollection.items[0].downloadAppButtons.downloadButtons.items[0].currentURL =
          justURLString();
        setPage(res.landingPageAppCollection.items[0]);
      })
      .catch((errors) => {
        console.log(errors);
      });
  }, [location.pathname]);

  if (!page) {
    return <Loading />;
  }

  return (
    <div className="container-fluid  main-container ">
      <Helmet htmlAttributes={{ lang: page.seoMetadata.hreflang }}>
        <meta charSet="utf-8" />
        <title>{page.pageTitle}</title>
        <meta name="description" content={page.seoMetadata.description}></meta>
        <meta name="keywords" content={page.seoMetadata.keywords}></meta>
        <link
          rel="alternate"
          hreflang={page.seoMetadata.hreflang}
          href={page.seoMetadata.href}
        />
        <link rel="canonical" href={page.canonicalHref} />
      </Helmet>

      <TopMenu
        urlAppButtos={page.downloadAppButtons.downloadButtons}
        urlAccount={page.urlAccount}
      />
      <Header logo={page.nav.logo} menuItems={page.nav.menuItems.menu} />

      {/* <Element name="test1" className="element" >  */}
      <section className="pt-1">
        <div>
          <h1 className="d-none">{page.pageTitle}</h1>
          <LandingCarousel
            data={page.carouselLp}
            downloadAppButtons={page.downloadAppButtons}
          />
        </div>
      </section>

      <section className="container-fluid pt-1 pb-4">
        <MultiCarousel data={page.multiCarouselCollection} />
      </section>
      {/* </Element>   */}

      {/* <Element name="test2" className="element" >  */}
      <section>
        <Promotions data={page.promotions} keyCountry={keyCountry} />
      </section>

      <section className="container  uses-container p-4 ">
        <div className="row h-100 ">
          <div className="col-md-4  d-flex justify-content-center align-items-center ">
            <img
              className="col-12  img-left-uses"
              src={page.uses.leftImage.url}
              alt="mockImage"
            />
          </div>
          <div className="col-md-8  p-4  d-flex justify-content-center aling-items-center">
            <div className=" col-11 p-3">
              <div className="col-12  p-3">
                <div>
                  {/* TU DINERO, MÁS FÁCIL, MÁS RÁPIDO Y MÁS SEGURO. */}
                  {documentToReactComponents(page.uses.text.json)}
                </div>
              </div>
              <div className="col-12   ">
                <div className="row h-100  d-flex justify-content-center">
                  {page.uses.uses.items.map((item, index) => {
                    return (
                      <div
                        key={index}
                        id={"benefits-" + index}
                        className="col-uses-item  p-1"
                      >
                        <a href={item.cta}>
                          <div className="d-flex p-1 justify-content-center">
                            <img
                              className="col-5"
                              src={item.icon}
                              alt={item.alt}
                            ></img>
                          </div>
                          <div className="text-uses-item p-1 ">
                            {item.label}
                          </div>
                        </a>
                      </div>
                    );
                  })}
                  {/* <div className='col-uses-item '></div>
                                    <div className='col-uses-item '></div>
                                    <div className='col-uses-item '></div>
                                    <div className='col-uses-item '></div>
                                    <div className='col-uses-item '></div>
                                    <div className='col-uses-item '></div> */}
                </div>
              </div>

              <div className="col-12 col-md-12 text-center p-1  mt-4  ">
                <DownloadApp showTitle={false} data={page.downloadAppButtons} />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* </Element>                            */}

      {/* <Element name="test3" className="element" >                          */}
      <div className="pb-4"></div>
      <div className="pb-4"></div>
      <div className="p-3">
        <section className="container  p-2   continer-benefits d-flex justify-content-center  ">
          <div className="col-12 text-center pt-4   ">
            {/* <h2>¿Qué esperas? ¡Empieza a aprovechar Tigo Money!</h2> */}
            <h2>{page.benefits.title}</h2>
            <div className="col-12   h-75    ">
              <div className="row no-padding d-flex justify-content-center">
                {page.benefits.benefits.items.map((item, index) => {
                  return (
                    <div
                      key={index}
                      id={"uses-" + index}
                      className="col-benefits  p-2"
                    >
                      <div>
                        <img src={item.image} alt={item.alt} />
                      </div>
                      <a href={item.cta_btn} target="_blank" rel="noreferrer">
                        <button className="btn-benefit">{item.btn_text}</button>
                      </a>
                      <div className="alt-text-benefit">{item.text}</div>
                    </div>
                  );
                })}
              </div>
              {/* <div className="col-benefits  p-2">
                            <img src={ImgBenefit1} alt=""/>
                            <button className='btn-benefit'>Descarga la app</button>
                            <div className='alt-text-benefit'>
                                Busca en Google Play o App Store
                            </div>
                        </div>
                        <div className="col-benefits  p-2">
                            <img src={ImgBenefit2} alt=""/>
                            <button className='btn-benefit'>Regístrate</button>
                            <div className='alt-text-benefit'>
                                Sólo necesitas tu DNI y una Selfie
                            </div>
                        </div>
                        <div className="col-benefits  p-2">
                            <img src={ImgBenefit3} alt=""/>
                            <button className='btn-benefit'>Disfruta</button>
                            <div className='alt-text-benefit'>
                            Paga, compra, envía, y aprovecha
                            </div>
                        </div> */}
            </div>
            <div className="pt-4"></div>
            <div className="pt-4"></div>
          </div>
        </section>
      </div>

      <section className="container d-flex justify-content-center  p-4 mt-4 ">
        {/* <h2>¡Descarga YA!</h2> */}
        <div className="col-12 col-sm-8 col-md-4 text-center ">
          <DownloadApp showTitle={true} data={page.downloadAppButtons} />
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </section>

      <Footer data={page.footer} />
      <div className=" p-1 container-fluid  tyc-container d-flex justify-content-center">
        <LinkRoute
          to={"/legales?id=homePageCollection&slug=home-" + keyCountry}
        >
          Términos y Condiciones
        </LinkRoute>
      </div>
      {/* </Element>                 */}
    </div>
  );
};

export default LandingPage;
